import 'Plugins/inViewportPlugin';


// in view port init
export default function initInViewport() {
  jQuery('.viewport-section').itemInViewport({
    visibleMode: 3
  });
}

